/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { categories, Category, CategoryType } from '../common/Categories';
import { isAdministrator } from '../common/common';
import { useradminRoute, userRoleRoute, editUserRoute, editUserRoleRoute } from '../common/constants';
import MyTab from './MyTab';
import Role from './Role';
import RoleEdit from './RoleEdit';
import UserEdit from './UserEdit';
import UserTable from './UserTable';
import { withRouterCompat, RouteComponentPropsCompat } from '../common/withRouter';

interface Props extends RouteComponentPropsCompat {
    classes?: any;
    navigate?: (path: string) => void;
}
const styles = (theme: Theme) => ({
    root: {
        width: '100%',
    }
});
class UserAdmin extends React.Component<Props>{
    state = {
        selectedCategoryId: 6
    };
    componentDidMount() {
        if (!isAdministrator()) {
            this.props.navigate?.('/');
        }
        this.setSelectedTab();
    }
    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        const prevPath = prevProps.location?.pathname || '';
        const currentPath = this.props.location?.pathname || '';
        if (prevPath === currentPath) {
        return;
        }
        this.setSelectedTab();
    }
    setSelectedTab = () => {
        if (this.props.location !== undefined) {
            if (this.props.location.pathname.indexOf('userrole') !== -1) {
                this.setState({ selectedCategoryId: 7 });
            }
            else if (this.props.location.pathname.indexOf('useradmin') !== -1) {
                this.setState({ selectedCategoryId: 6 });
            }
        }
    };
    handleTabChange(categoryId: number) {
        if (categoryId !== undefined) {
            this.setState(
                {
                    selectedCategoryId: categoryId
                }
            );
            if (categoryId === 6) {
                this.props.navigate?.('/useradmin');
            }
            else if (categoryId === 7) {
                this.props.navigate?.('/useradmin/userrole');
            }
        }
    }
    render() {
        const { classes } = this.props;
        const filteredCategories: Array<Category> = categories.filter((category: Category) => {
            return category.type === CategoryType.User || category.type === CategoryType.UserRole;
        });

        return (
            <div>
                <div className={classes.root}>
                    <Grid container spacing={2}>
                        <div>
                            <MyTab
                                categories={filteredCategories}
                                selectedTab={this.state.selectedCategoryId}
                                onTabChange={this.handleTabChange.bind(this)}
                            />
                            <br />
                        </div>
                    </Grid>
                    <Routes>
                        <Route index element={<UserTable />} />
                        <Route path="/edituser/:userid" element={<UserEdit />} />
                        <Route path="userrole" element={<Role />} />
                        <Route path="userrole/edituserrole/:roleid" element={<RoleEdit />} />
                    </Routes>
                </div>
            </div>
        );
    }
}

export default withRouterCompat(withStyles(styles)(UserAdmin));
